import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {GET_RESIT_REGISTRATION_REVIEW} from '../../constants/apiUrls';
import {GetSubjectSummaryResponse} from '../../api/candidate/resit/model';
import {CandidateProfileResponse} from '../../api/candidate/profile/@candidate/models';
import {useCustomQuery} from '../../hooks/query';
import {GET_RESIT_REGISTRATION_REVIEW_KEY} from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface CandidateProfileAndResitResponse {
  subjectSummary: GetSubjectSummaryResponse;
  candidateDetails: CandidateProfileResponse;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: CandidateProfileAndResitResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  enabled?: boolean;
}

export const useGetCandidateProfileAndResit = ({
                                                 uuid,
                                                 onSuccess,
                                                 onError,
                                                 enabled = true,
                                               }: Input) => {
  const getCandidateProfileAndResit = async () => {
    const res = await axiosClient.get<CandidateProfileAndResitResponse>(
        GET_RESIT_REGISTRATION_REVIEW(uuid)
    );
    return res.data;
  };

  return useCustomQuery(GET_RESIT_REGISTRATION_REVIEW_KEY, getCandidateProfileAndResit, {
    onSuccess,
    onError,
    enabled,
  });
};
